import React from 'react';
import { AgentDetails } from '../components/AgentMarketplace';

const AgentDetailsPage = () => {
  return <AgentDetails />;
};

export default AgentDetailsPage; 